import React, { useEffect } from 'react';
import { FAQ } from '../components/home/FAQ';
export function FAQPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen bg-dark-bg" data-id="element-759">
      <FAQ data-id="element-760" />
    </main>;
}